import { IHierarchyDetails } from "modules/CarrierAgreementMgmt/Hierarchy/types";
export default function HierarchyBulkFilter(datas: IHierarchyDetails[]) {
  // Get the Root
  let root = datas.filter(
    (data) => data.parentId === "" || data.parentId == null
  );
  root[0].parentIds = "";

  // Get the Children of Root
  let hierarchyType = datas.filter(
    (data) => data.parentId === root[0].id.toString()
  );

  let region: any[] = [];
  let sections: any[] = [];
  let childList: any[] = [];
  // Distribute the datas
  datas.forEach((data) => {
    if (data.parentId === root[0].id.toString()) {
      let x = { ...data };
      region[data.id] = [];
      sections[data.id] = [];
      childList[data.id] = [];
      childList[data.id].push(data.id);
      x.parentId = "";
      x.parentIds = root[0].id.toString();
      sections[data.id].push(x);
    } else {
      // sorting for hierarchyType childrens and grandchildren
      let pass = false;
      hierarchyType?.forEach((child) => {
        if (child.id.toString() === data.parentId) {
          region[child.id]?.push(data);
        }
        if (
          child.id.toString() === data.parentId ||
          child.id.toString() === data.parentIds
        ) {
          childList[child.id]?.push(data.id);
          sections[child.id]?.push(data);
          pass = true;
        }
      });
      // Sorting of Associated Office
      if (!pass) {
        childList.forEach((value, key) => {
          if (value.includes(Number(data.parentId))) {
            childList[key].push(data.id);
            sections[key].push(data);
          }
        });
      }
    }
  });

  let order: number[] = [];
  hierarchyType.forEach((child) => {
    order.push(child.id);
  });
  // for the root numbering
  region.forEach((child) => {
    hierarchyType = hierarchyType.concat(child);
  });

  hierarchyType.push(root[0]);

  return { sections, hierarchyType, order };
}
